export const DIRECT_UPLOAD_ACTIONS = {
    SET_UPLOAD: 'SET_DIRECT_UPLOAD',
    SET_PROGRESS: 'SET_DIRECT_UPLOAD_PROGRESS',
    SET_ERROR: 'SET_DIRECT_UPLOAD_ERROR',
    REMOVE_UPLOAD: 'REMOVE_DIRECT_UPLOAD',
    CLEAR_ALL: 'CLEAR_DIRECT_UPLOADS'
};
export const initialDirectUploadState = {
    uploads: {}
};
